/* eslint-disable react/jsx-props-no-spreading */
import '../styles/globals.css';

import * as amplitude from '@amplitude/analytics-browser';
import Head from 'next/head';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const MyApp = ({ Component, pageProps }) => {
  const [isClient, setIsClient] = useState(false);

  let pageName;

  useEffect(() => {
    // Mark that we're on client-side
    setIsClient(true);

    // Initialize analytics only on client-side
    if (typeof window === 'undefined') return;

    try {
      const userStr = localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : null;

      if (user) {
        amplitude.init('27b620d609eeb9d1d0c15aa0aaeb95b1', user._id, {
          defaultTracking: true,
        });

        const identifyEvent = new amplitude.Identify();
        identifyEvent.set('companyName', user.companyName);
        identifyEvent.set('userType', user.type);

        amplitude.identify(identifyEvent);
      } else {
        amplitude.init('27b620d609eeb9d1d0c15aa0aaeb95b1', null, {
          defaultTracking: true,
        });
      }
    } catch (error) {
      console.error('Error initializing analytics:', error);
      amplitude.init('27b620d609eeb9d1d0c15aa0aaeb95b1');
    }
  }, []);

  if (typeof window !== 'undefined') {
    const pathName = window.location.pathname.split('/');
    pageName = pathName
      .pop()
      .replace(/-/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(' ');

    if (parseInt(pageName, 10)) {
      if (pathName.includes('ship')) {
        pageName = 'Edit Ship';
      } else if (pathName.includes('offer')) {
        pageName = 'View Offer';
      } else if (pathName.includes('service-request')) {
        pageName = 'View Service Request';
      } else if (pathName.includes('supplier')) {
        pageName = 'View Supplier Profile';
      } else if (pathName.includes('troubleshooting-request')) {
        pageName = 'View Troubleshooting Request';
      } else if (pathName.includes('guides')) {
        pageName = 'Guides';
      }
    }
  }

  const finalPageName = pageName
    ? `${pageName} | bid2board`
    : 'bid2board | Digitalizing Marine Technical Service';

  const googleAnalyticsScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    try {
      const userId = localStorage.getItem('userId');
      const user = JSON.parse(localStorage.getItem('user') || 'null');

      if (user?.companyName !== 'Bid2board' && window.location.href.startsWith("https://bid2board.com")) {
        gtag('config', 'G-D06X6T3HK6', { user_id: userId });
        gtag('set', 'user_properties', { company_name: user ? user.companyName : '' });
      } else {
        gtag('config', 'G-D06X6T3HK6');
      }
    } catch (e) {
      console.error('Analytics error:', e);
      gtag('config', 'G-D06X6T3HK6');
    }
  `;

  return (
    <>
      <Head>
        <title>{finalPageName}</title>
        <meta property="og:title" content={finalPageName} key="title" />
        <meta property="og:type" content="article" />
        <meta
          property="og:description"
          content="bid2board ensures quality and efficiency, reduces the time required to arrange service and enhances visibility through a simple and automated platform"
        />
        <meta
          property="og:image"
          content="https://bid2board.com/bid2board-social.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>

      {isClient && (
        <>
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=G-D06X6T3HK6"
            strategy="afterInteractive"
          />
          <Script
            id="google-analytics"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{ __html: googleAnalyticsScript }}
          />
        </>
      )}

      <Component {...pageProps} />
    </>
  );
};

export default MyApp;
